<script setup lang="ts">

import type { Praeparat } from '@/types/otc/praeparat'
import {computed} from "vue";
import ProductImageBase from "@/vue_components/praeparate/shared/product-detail-image/ProductImageBase.vue";

interface Props {
  praeparat: Praeparat | null
  dictionary: Record<string, string>
}

const props = defineProps<Props>()

const imageCaption = computed(() =>
    props.dictionary['PRODUKTE_IMG_Caption'] || ''
)

</script>

<template>
  <figure class="figure-product-img">
    <ProductImageBase
        :praeparat="praeparat"
        :width="405"
        :quality="100"
        :transparent="false"
        :use-bg-color="false"
        :show-caption="true"
        :caption="imageCaption"
        :alt-text="praeparat?.name"
    />
  </figure>
</template>

<style scoped>
/* RX-spezifische Image Styles */
</style>